<template>
    <div id="contenedor-main-listado-tipos-documentos">
        <template
            v-if="!$vuetify.breakpoint.xs">
            <desktop :listadoTiposDocumentos="listadoTiposDocumentos"></desktop>
        </template>
        <template
            v-else>
            <mobile :listadoTiposDocumentos="listadoTiposDocumentos"></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoTiposDocumentos',
  props: {
    listadoTiposDocumentos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
